import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { verifyPhonenumber, verifyEmailAddress, normalizePhonenumber } from '../common/common';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';

export default function PartyEditDialog(props) {
    const open = props.open;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [name, setName] = React.useState('');
    const [phonenumber, setPhonenumber] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [saving, setSaving] = React.useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setName('');
        setPhonenumber('');
        setEmail('');
    }, [props.open]);

    const cancel = () => {
        props.cancel();
    };

    return (
        <Dialog
            onClose={cancel}
            aria-labelledby="simple-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogTitle>{t('general.createNewContact')}</DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            disabled={saving}
                            error={!name}
                            id="partyName"
                            name="name"
                            label={t('general.name')}
                            value={name}
                            sx={{ mx: 1, width: '95%' }}
                            margin="normal"
                            onChange={(evt) => setName(evt.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            disabled={saving}
                            error={!verifyPhonenumber(phonenumber)}
                            id="partyTel"
                            name="phonenumber"
                            label={t('general.phone')}
                            value={phonenumber}
                            sx={{ mx: 1, width: '95%' }}
                            margin="normal"
                            onChange={(evt) => setPhonenumber(evt.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            disabled={saving}
                            error={!verifyEmailAddress(email)}
                            id="partyEmail"
                            name="email"
                            label={t('general.email')}
                            value={email}
                            sx={{ mx: 1, width: '95%' }}
                            margin="normal"
                            onChange={(evt) => setEmail(evt.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={
                        saving ||
                        !name ||
                        (!!phonenumber && !verifyPhonenumber(phonenumber)) ||
                        (!!email && !verifyEmailAddress(email))
                    }
                    sx={{ m: 1 }}
                    variant="contained"
                    color="primary"
                    name="btn-party-save"
                    onClick={async () => {
                        setSaving(true);
                        const normalizedPhone = normalizePhonenumber(phonenumber) || phonenumber;
                        await props.save({ name, phonenumber: normalizedPhone, email });
                        setSaving(false);
                    }}
                    startIcon={saving ? <CircularProgress color={'secondary'} size={'1rem'} /> : null}>
                    {t('buttons.save')}
                </Button>
                <Button
                    disabled={saving}
                    sx={{ m: 1 }}
                    variant="contained"
                    color="secondary"
                    name="btn-party-cancel"
                    onClick={cancel}>
                    {t('buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
